var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2414 39.7539C57.2825 39.7539 55.6946 41.3419 55.6946 43.3007V43.3007C55.6946 45.2595 57.2825 46.8475 59.2414 46.8475H177.419C179.378 46.8475 180.966 45.2595 180.966 43.3007V43.3007C180.966 41.3419 179.378 39.7539 177.419 39.7539H59.2414Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 40C57.567 40 56 41.567 56 43.5V43.5C56 45.433 57.567 47 59.5 47H161.193C163.126 47 164.693 45.433 164.693 43.5V43.5C164.693 41.567 163.126 40 161.193 40H59.5Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 40C25.8954 40 25 40.8954 25 42V45C25 46.1046 25.8954 47 27 47H45.0229C46.1275 47 47.0229 46.1046 47.0229 45V42C47.0229 40.8954 46.1275 40 45.0229 40H27Z",
    fill: "#A4A4A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2414 67.7539C57.2825 67.7539 55.6946 69.3419 55.6946 71.3007V71.3007C55.6946 73.2595 57.2825 74.8475 59.2414 74.8475H177.419C179.378 74.8475 180.966 73.2595 180.966 71.3007V71.3007C180.966 69.3419 179.378 67.7539 177.419 67.7539H59.2414Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 68C57.567 68 56 69.567 56 71.5V71.5C56 73.433 57.567 75 59.5 75H80.4211C82.3541 75 83.9211 73.433 83.9211 71.5V71.5C83.9211 69.567 82.3541 68 80.4211 68H59.5Z",
    fill: "#D1D1D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 68C25.8954 68 25 68.8954 25 70V73C25 74.1046 25.8954 75 27 75H45.0229C46.1275 75 47.0229 74.1046 47.0229 73V70C47.0229 68.8954 46.1275 68 45.0229 68H27Z",
    fill: "#A4A4A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2414 95.7539C57.2825 95.7539 55.6946 97.3419 55.6946 99.3007V99.3007C55.6946 101.26 57.2825 102.848 59.2414 102.848H177.419C179.378 102.848 180.966 101.26 180.966 99.3007V99.3007C180.966 97.3419 179.378 95.7539 177.419 95.7539H59.2414Z",
    fill: "#E1E1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 96C57.567 96 56 97.567 56 99.5V99.5C56 101.433 57.567 103 59.5 103H146.235C148.168 103 149.735 101.433 149.735 99.5V99.5C149.735 97.567 148.168 96 146.235 96H59.5Z",
    fill: "#D1D1D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 96C25.8954 96 25 96.8954 25 98V101C25 102.105 25.8954 103 27 103H45.0229C46.1275 103 47.0229 102.105 47.0229 101V98C47.0229 96.8954 46.1275 96 45.0229 96H27Z",
    fill: "#A4A4A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2414 123.754C57.2825 123.754 55.6946 125.342 55.6946 127.301V127.301C55.6946 129.26 57.2825 130.848 59.2414 130.848H177.419C179.378 130.848 180.966 129.26 180.966 127.301V127.301C180.966 125.342 179.378 123.754 177.419 123.754H59.2414Z",
    fill: "#E1E1E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 124C57.567 124 56 125.567 56 127.5V127.5C56 129.433 57.567 131 59.5 131H134.269C136.202 131 137.769 129.433 137.769 127.5V127.5C137.769 125.567 136.202 124 134.269 124H59.5Z",
    fill: "#D1D1D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 124C25.8954 124 25 124.895 25 126V129C25 130.105 25.8954 131 27 131H45.0229C46.1275 131 47.0229 130.105 47.0229 129V126C47.0229 124.895 46.1275 124 45.0229 124H27Z",
    fill: "#A4A4A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget.8d7fe1abfbdf0ee2c625bfe2b7e29d92.svg";
export { ForwardRef as ReactComponent };